module.exports = __webpack_public_path__ + "static/media/icon_done.f5fbf93e.svg";